import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createElementVNode as _createElementVNode, renderSlot as _renderSlot, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "py-md flex flex-row gap-sm p-xs items-stretch" };
const _hoisted_2 = { class: "flex self-baseline gap-sm" };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { class: "flex flex-col w-full overflow-hidden" };
const _hoisted_5 = { class: "flex min-h-[40px] pb-sm items-end" };
const _hoisted_6 = { class: "flex flex-col overflow-hidden" };
const _hoisted_7 = {
    key: 0,
    class: "flex flex-row items-center gap-xs"
};
const _hoisted_8 = /*#__PURE__*/ _createElementVNode("div", { class: "h-sm+* w-sm+* rounded-full bg-outline" }, null, -1);
const _hoisted_9 = { class: "typography-caption-regular text-outline" };
const _hoisted_10 = { class: "ml-auto" };
const _hoisted_11 = {
    key: 0,
    class: "flex w-full flex-col gap-sm justify-between typography-caption-regular text-outline md:flex-row"
};
const _hoisted_12 = { class: "overflow-hidden flex flex-col gap-sm" };
const _hoisted_13 = {
    key: 2,
    class: "flex whitespace-nowrap"
};
const _hoisted_14 = { class: "overflow-hidden text-ellipsis" };
const _hoisted_15 = { class: "typography-body-2-bold" };
const _hoisted_16 = { class: "whitespace-nowrap" };
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_OrIconButton = _resolveComponent("OrIconButton");
    const _component_OrIcon = _resolveComponent("OrIcon");
    const _component_OrAvatar = _resolveComponent("OrAvatar");
    const _component_OrText = _resolveComponent("OrText");
    const _component_OrTag = _resolveComponent("OrTag");
    return (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
            _createVNode(_component_OrIconButton, {
                icon: _ctx.expanded ? 'keyboard_arrow_up' : 'keyboard_arrow_down',
                onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.expanded = !_ctx.expanded))
            }, null, 8, ["icon"]),
            _createVNode(_component_OrAvatar, {
                size: "m",
                class: _normalizeClass({ '!bg-disabled': _ctx.meta.status !== 'shared' }),
                "color-salt": _ctx.meta.target_account
            }, {
                default: _withCtx(() => [
                    (_ctx.meta.status !== 'pending')
                        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(_ctx.getAbbreviation(_ctx.meta.account_name)), 1))
                        : (_openBlock(), _createBlock(_component_OrIcon, {
                            key: 1,
                            class: "text-on-disabled",
                            icon: "person"
                        }))
                ]),
                _: 1
            }, 8, ["class", "color-salt"])
        ]),
        _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", _hoisted_6, [
                    _createVNode(_component_OrText, {
                        class: _normalizeClass(["typography-body-2-regular", { 'text-on-disabled': _ctx.meta.status === 'pending' }]),
                        text: _ctx.meta.account_name ? _ctx.meta.account_name : _ctx.meta.target_account
                    }, null, 8, ["class", "text"]),
                    (_ctx.meta.status === 'pending')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                            _hoisted_8,
                            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('contacts.shareModal.waitingForResponse')), 1)
                        ]))
                        : _createCommentVNode("", true)
                ]),
                _createElementVNode("div", _hoisted_10, [
                    _renderSlot(_ctx.$slots, "action")
                ])
            ]),
            (_ctx.expanded)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                        (_ctx.getDeletedFromText && _ctx.showDeletedTag)
                            ? (_openBlock(), _createBlock(_component_OrTag, { key: 0 }, {
                                default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.getDeletedFromText), 1)
                                ]),
                                _: 1
                            }))
                            : _createCommentVNode("", true),
                        (_ctx.meta.approved_by)
                            ? (_openBlock(), _createBlock(_component_OrText, {
                                key: 1,
                                text: _ctx.$t('contactBooks.approvedBy', { name: _ctx.meta.approved_by })
                            }, null, 8, ["text"]))
                            : _createCommentVNode("", true),
                        (_ctx.meta.custom_book_name)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                                _createElementVNode("span", _hoisted_14, [
                                    _createTextVNode(_toDisplayString(_ctx.$t('contacts.shareModal.BookName') + ': '), 1),
                                    _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.meta.custom_book_name), 1)
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _createElementVNode("span", _hoisted_16, _toDisplayString(_ctx.time), 1)
                ]))
                : _createCommentVNode("", true)
        ])
    ]));
}
